module.exports = __webpack_public_path__ + "img/box9-22.0ed4c51f.png";